// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__-p7p5","content":"styles_content__3YrSW"};